import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export const trackAmplitudeNavigationClick = (sectionName: string, sectionNumber: number | undefined, selectedTab: string) => {
    trackAmplitudeEvent("select_section", {
        section_name: sectionName,
        ...(sectionNumber != null ? {section_number: sectionNumber} : {}),
        selected_tab: selectedTab
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export const trackAmplitudeNavigationClick = (sectionName: string, sectionNumber: number | undefined, selectedTab: string) => {
    trackAmplitudeEvent("select_section", {
        section_name: sectionName,
        ...(sectionNumber != null ? {section_number: sectionNumber} : {}),
        selected_tab: selectedTab
    });
};
